// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"6c8a2afb","339":"4b317a5a","527":"0444385a","573":"bbfafef3","774":"d3828621"}[chunkId] + ".chunk.js";
};